// Determine WebSocket protocol
// const isSecure = process.env.REACT_APP_WEBSOCKET_SECURE === "true";
// const wsProtocol = isSecure ? "wss" : "ws";

// Export configuration
export const API_URL = `${process.env.REACT_APP_API_URL}/api`;
export const STORAGE_URL = process.env.REACT_APP_STORAGE_URL;
export const WEBSOCKET_URL = `${process.env.REACT_APP_DOMAIN}:${process.env.REACT_APP_WEBSOCKET_PORT}/my-websocket`;

// ---------- Public website ----------
export const APP_NAME = "CFCM Portal";
export const MINISTRY_NAME = "Commissioners for Christ Ministry";

// The ministry's main website and the pages on it that this portal links to.
export const MINISTRY_SITE_URL = "https://cfcm.co.ke";
export const MEMBERSHIP_URL = "https://cfcm.co.ke/cfcm-membership";
export const PROGRAMS_URL = "https://cfcm.co.ke/programs";

export const SOCIAL_LINKS = [
    { name: "Facebook", url: "https://www.facebook.com/cfcmministry/" },
    { name: "Instagram", url: "https://instagram.com" },
    { name: "X (Twitter)", url: "https://x.com/commissionersm" },
    { name: "YouTube", url: "https://www.youtube.com/@commissionersforchristmini3727" },
];

// The company that built the portal.
export const ZANIFY_URL = "https://zanifytech.com";

// Google reCAPTCHA ("I'm not a robot") on the public forms. Leave the key out
// to switch it off. The API holds the matching secret key.
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";
